// export const apiEndpoint = "http://192.168.1.13:5000/api/";
// export const mainWebsite = "http://localhost:3000";
// export const corporateEndpoint = "http://192.168.1.13:3000";
// export const imageUrl = "http://192.168.1.13:5000/";

export const apiEndpoint = "http://node.qhide.com:5001/api/";
export const mainWebsite = "http://qhide.com";
export const corporateEndpoint = "http://qhide.com";
export const imageUrl = "http://node.qhide.com:5001/";
